<template>
  <div class="cs-simple-header">
    <h3 class="title">
      <slot name="title">{{ title }}</slot>
    </h3>
    <div class="cs-simple-operation">
      <slot>
        <el-button
          @click="item.action"
          v-for="item in buttons"
          :size="item.size"
          :key="item.label"
          :type="item.type"
          :plain="item.plain"
          :round="item.round"
          :circle="item.circle"
          :loading="item.loading"
          :disabled="item.disabled"
          :icon="item.icon"
          :autofocus="item.autofocus"
          :native-type="item.nativeType"
        >
          {{ item.label }}
        </el-button>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "CsSimpleHeader",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    buttons: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.cs-simple-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  border-bottom: 1px solid #aaa;
  .title {
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
